<template>
  <DatatableUserText
    v-if="isUserTextDatatableField(field)"
    :field="field"
    :value="value"
  />
  <span v-else>{{ value }}</span>
</template>

<script>
import { isUserTextDatatableField } from '@/libs/datatableUserText'
import DatatableUserText from '@/views/Components/Elements/DatatableUserText.vue'

export default {
  name: 'DatatableCellValue',
  components: {
    DatatableUserText,
  },
  props: {
    field: {
      type: String,
      required: true,
    },
    value: {
      default: null,
    },
  },
  methods: {
    isUserTextDatatableField,
  },
}
</script>
